<template>
  <b-container fluid>
    <h1>Annual and Cumulative Interactions</h1>
    <div v-if="loaded">
      <mio-output
        title="Annual"
        :method="InteractionSummaryData.method"
        :messages="InteractionSummaryData.messages"
        :tables="InteractionSummaryData.annualTables"
      />
      <mio-output
        title="Cumulative"
        :messages="InteractionSummaryData.messages"
        :tables="InteractionSummaryData.cumulativeTables"
      />
    </div>
    <h2 v-else class="loading-placeholder">Loading...</h2>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import { set, get, validateRow } from "@/utils/MioHelpers";
import MioOutput from "@/components/MioOutput";

export default {
  name: "MioAnnualInteractions",
  components: {
    MioOutput
  },
  data() {
    return {
      loaded: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
      GET_ANNUAL_CUMULATIVE_INTERACTIONS_DATA: "mio/GET_ANNUAL_CUMULATIVE_INTERACTIONS_DATA"
    }),
    async getData() {
      try {
        await this.GET_ANNUAL_CUMULATIVE_INTERACTIONS_DATA();

        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    }
  },
  computed: {
    InteractionSummaryData: {
      get() {
        const working = this.$store.state.mio.annualCumulativeInteractionsData,
          output = {
            method:
              "Schools and teachers engaged per year are calculated by counting the unique entries per country per year in the classroom observations records. Student engagement is derived by filtering unique students per country per year from the student attendance records. Certificates are counted from entries marked 'certificate ceremony' in the training modules records. Class visits are counted using the raw records in the classroom observations table. ",
            messages: [],
          },
          tablesData = [{
            title: "schools engaged with",
            annual: "schools",
            cumulative: "cumulativeSchools",
          },
          {
            title: "students engaged with",
            annual: "students",
            cumulative: "cumulativeStudents",
          },
          {
            title: "teachers engaged with",
            annual: "teachers",
            cumulative: "cumulativeTeachers",
          },
          {
            title: "modules taught",
            annual: "modules",
          },
          {
            title: "Module groups starting",
            annual: "moduleGroups",
          },
          {
            title: "Maintenance groups starting",
            annual: "maintenanceGroups",
          },
          {
            title: "Module visits undertaken",
            annual: "moduleVisits",
          },
          {
            title: "Maintenance visits undertaken",
            annual: "maintenanceVisits",
          },
          {
            title: "teachers entering Module phase",
            annual: "moduleTeachersStarting",
          },
          {
            title: "teachers entering Maintenance phase",
            annual: "maintenanceTeachersStarting",
          },
          {
            title: "teachers currently in Module phase (by group's start year)",
            annual: "activeModuleTeachers",
          },
          {
            title: "teachers currently in Maintenance phase (by group's start year)",
            annual: "activeMaintenanceTeachers",
          },
          {
            title: "teachers visited under Module programme",
            annual: "moduleTeachers",
            cumulative: false,
          },
          {
            title: "teachers visited under Maintenance programme",
            annual: "maintenanceTeachers",
            cumulative: false,
          },
          {
            title: "teachers who dropped out of the Module programme (from 2024)",
            annual: "moduleDropoffs",
          },
          {
            title: "teachers who dropped out of the Maintenance programme (from 2024)",
            annual: "maintenanceDropoffs",
          },
          {
            title: "teachers who completed the Module programme but did not enter Maintenance",
            annual: "completedModuleNotMaintenanceTeachers",
          },
          {
            title: "Perivoli certificates awarded",
            annual: "certificates",
          },
          {
            title: "support groups held",
            annual: "workshops",
          },
          {
            title: "total consent forms signed",
            annual: "consent",
          },
          {
            title: "teacher consent forms signed",
            annual: "teacherConsent",
          },
          {
            title: "parent consent forms signed",
            annual: "parentConsent",
          },
          {
            title: "student consent forms signed",
            annual: "studentConsent",
          }];

        // Format for output
        const formatData = (table, data, cols = data.cols) => ({
            title: table.title,
            cols,
            rows: Object.keys(data.rows)
              .sort()
              .reverse()
              .map(year => ({
                title: year,
                data: cols.map(country => data.rows[year][country])
              }))
          });

        output.annualTables = tablesData.map(table => formatData(table, working[table.annual].data));
        output.cumulativeTables = tablesData
          .filter(table => table.cumulative !== false)
          .map(table => formatData(
              table,
              working[table.cumulative] ? working[table.cumulative].data : working[table.annual].cumulativeData,
              working[table.annual].data.cols
          ));

        return output;
      }
    }
  }
};
</script>
